export const environment = {
  production: false,
  configFile: 'assets/config/config.json'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts